






import Vue from 'vue'
import Component from 'vue-class-component'
import IconBase from './components/IconBase.vue'

    @Component({
      components: {
        'IconBase': IconBase
      }
    })

export default class App extends Vue {
}
